import { set } from '@graphcommerce/ecommerce-ui'
import { AccountOrdersFragment } from '@graphcommerce/magento-customer/components/AccountOrders/AccountOrders.gql'
import useOrderCardItemImages from '@graphcommerce/magento-customer/hooks/useOrderCardItemImages'
import { extendableComponent } from '@graphcommerce/next-ui'
import { Box, Pagination, SxProps, Theme } from '@mui/material'
import { NoActiveOrders } from '../../CustomerOrder/NoActiveOrders'
import { NoCanceledOrders } from '../../CustomerOrder/NoCanceledOrders'
import { NoOrdersFound } from '../../CustomerOrder/NoOrdersFound'
import { OrderCard } from '../../CustomerOrder/OrderCard/OrderCard'

export type AccountOrdersProps = AccountOrdersFragment & { sx?: SxProps<Theme> } & {
  reviews?: any
  currentPage?: number
  setCurrentPage?: (page: number) => void
  pageSize?: number
  activeTab?: number
}

const parts = ['root', 'older'] as const
const { classes } = extendableComponent('AccountOrders', parts)

export function AccountOrders(props: AccountOrdersProps) {
  const { orders, sx = [], reviews, currentPage, setCurrentPage, pageSize, activeTab } = props
  const images = useOrderCardItemImages(orders)

  const pageInfo = orders?.page_info
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    if (setCurrentPage) {
      setCurrentPage(value ?? 1)
    }
  }

  return (
    <Box
      className={classes.root}
      sx={[
        (theme) => ({
          typography: 'body2',
          marginBottom: theme.spacings.md,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <div className='flex flex-col gap-4'>
        {orders?.items?.map(
          (order) =>
            order && <OrderCard key={order.number} {...order} images={images} reviews={reviews} />,
        )}
        {orders?.items && orders?.items?.length < 1 && activeTab === 1 && <NoOrdersFound />}
        {orders?.items && orders?.items?.length < 1 && activeTab === 0 && <NoActiveOrders />}
        {orders?.items && orders?.items?.length < 1 && activeTab === 2 && <NoCanceledOrders />}
      </div>

      {orders?.items && orders?.items?.length > 0 && (
        <div className='mt-7 flex w-full items-center justify-center'>
          <Pagination
            count={pageInfo?.total_pages ?? 1}
            showFirstButton
            showLastButton
            color='secondary'
            shape='rounded'
            page={currentPage ?? 1}
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            onChange={handleChange}
          />
        </div>
      )}
    </Box>
  )
}
